/* eslint-disable import/order */
import { createApp } from "vue";
import { DateTime, Duration } from "luxon";

import "@/styles/bootstrap.scss";
import "@/styles/vendor.scss";

import "bootstrap";
import VueFeather from "vue-feather";
import Toast, { POSITION } from "vue-toastification";

import App from "@/App.vue";
import { AuthenticationPlugin as auth } from "@/auth";
import router from "@/router";
import store from "@/store";
import "@/api/axios";

const app = createApp(App)
  .use(store)
  .use(router)
  .use(auth)
  .use(Toast, { position: POSITION.BOTTOM_RIGHT })
  .component(VueFeather.name, VueFeather);

app.config.globalProperties.$luxon = DateTime;
app.config.globalProperties.$luxonDuration = Duration;

app.mount("#app");
